import { createSlice } from '@reduxjs/toolkit';
import { IExperiment } from 'shared/types/experiments';

export const experimentsSlice = createSlice({
  name: 'experiments',
  initialState: [] as IExperiment[],
  reducers: {},
});

export const { reducer: experimentsReducer, name: experimentsReducerName } = experimentsSlice;
